import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { EditTopBannerForm } from '~/features/EditTopBannerForm';

export const Screen: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const topBannerId = Number(id);

  if (Number.isNaN(topBannerId)) {
    return <div>無効なバナーIDです</div>;
  }

  return (
    <Suspense fallback={<Loader />}>
      <EditTopBannerForm topBannerId={topBannerId} />
    </Suspense>
  );
};
